<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  label: string
  value: number | null | undefined
  unit?: string
}>()

const isEmpty = computed(
  () => props.value === null || props.value === undefined || Number.isNaN(Number(props.value)),
)

const numberText = computed(() =>
  isEmpty.value ? '—' : Number(props.value).toLocaleString('pt-BR', { maximumFractionDigits: 2 }),
)

const prefix = computed(() => (props.unit === 'R$' ? 'R$' : ''))
const suffix = computed(() => (props.unit && props.unit !== 'R$' ? props.unit : ''))
</script>

<template>
  <div class="border border-stroke bg-white px-3 py-1.5">
    <h3 class="truncate text-[10px] font-medium uppercase tracking-wide text-slate-500" :title="label">{{ label }}</h3>
    <p class="flex items-baseline gap-1 whitespace-nowrap leading-tight">
      <span v-if="prefix" class="text-base font-semibold text-slate-500">{{ prefix }}</span>
      <span class="text-2xl font-bold text-slate-900">{{ numberText }}</span>
      <span v-if="suffix" class="text-xs font-medium text-slate-400">{{ suffix }}</span>
    </p>
  </div>
</template>
